import i18n from '@/locales'
import { WORKFLOW_TYPES } from '@/constants/workflow'

export const TYPES = [
  {
    key: 'local',
    label: i18n.t('system.text_541'),
  },
  {
    key: 'third',
    label: i18n.t('system.text_542'),
  },
]

/** 各类型工单的使用说明（i18n key） */
export const WORKFLOW_USAGE_TIPS = {
  [WORKFLOW_TYPES.APPLY_MACHINE]: 'system.workflow_usage.apply_machine',
  [WORKFLOW_TYPES.APPLY_SERVER_CHANGECONFIG]: 'system.workflow_usage.apply_server_changeconfig',
  [WORKFLOW_TYPES.APPLY_SERVER_DELETE]: 'system.workflow_usage.apply_server_delete',
  [WORKFLOW_TYPES.APPLY_SERVER_STOP]: 'system.workflow_usage.apply_server_stop',
  [WORKFLOW_TYPES.APPLY_SERVER_START]: 'system.workflow_usage.apply_server_start',
  [WORKFLOW_TYPES.APPLY_SERVER_RESTART]: 'system.workflow_usage.apply_server_restart',
  [WORKFLOW_TYPES.EXECUTE_RESOURCE_ORDER_SET]: 'system.workflow_usage.execute_resource_order_set',
  [WORKFLOW_TYPES.APPLY_JOIN_PROJECT]: 'system.workflow_usage.apply_join_project',
  [WORKFLOW_TYPES.APPLY_PROJECT_QUOTA]: 'system.workflow_usage.apply_project_quota',
  [WORKFLOW_TYPES.APPLY_DOMAIN_QUOTA]: 'system.workflow_usage.apply_domain_quota',
  [WORKFLOW_TYPES.APPLY_INTERNAL_RESOURCE]: 'system.workflow_usage.apply_internal_resource',
  [WORKFLOW_TYPES.CUSTOMER_SERVICE]: 'system.workflow_usage.customer_service',
  [WORKFLOW_TYPES.ALERT_EVENT]: 'system.workflow_usage.alert_event',
  [WORKFLOW_TYPES.ALERT_TICKET]: 'system.workflow_usage.alert_ticket',
  [WORKFLOW_TYPES.EXECUTE_USER_JOIN]: 'system.workflow_usage.execute_user_join',
  [WORKFLOW_TYPES.EXECUTE_USER_UPDATE]: 'system.workflow_usage.execute_user_update',
  [WORKFLOW_TYPES.EXECUTE_USER_DELETE]: 'system.workflow_usage.execute_user_delete',
  [WORKFLOW_TYPES.EXECUTE_ROLE_SET_POLICIES]: 'system.workflow_usage.execute_role_set_policies',
  [WORKFLOW_TYPES.EXECUTE_ROLEPOLICY_BATCH_DELETE]: 'system.workflow_usage.execute_rolepolicy_batch_delete',
  [WORKFLOW_TYPES.EXECUTE_POLICY_UPDATE]: 'system.workflow_usage.execute_policy_update',
  [WORKFLOW_TYPES.EXECUTE_POLICY_ENABLE]: 'system.workflow_usage.execute_policy_enable',
  [WORKFLOW_TYPES.EXECUTE_POLICY_DISABLE]: 'system.workflow_usage.execute_policy_disable',
}

/** 已废弃但保留可用性的工单：需要按启用/禁用状态追加不同的说明后缀 */
export const DEPRECATED_WORKFLOW_TYPES = [
  WORKFLOW_TYPES.APPLY_MACHINE,
  WORKFLOW_TYPES.APPLY_SERVER_CHANGECONFIG,
]

/** 是否为已废弃（禁用状态）的主机申请 / 主机调整配置工单 */
export const isDeprecatedWorkflow = (key, suspended) => {
  return DEPRECATED_WORKFLOW_TYPES.includes(key) && suspended === true
}

/** 按工单类型 key 取使用说明，未登记的返回 '-'；suspended 为 true 表示已禁用 */
export const getWorkflowUsageTip = (key, suspended) => {
  const i18nKey = WORKFLOW_USAGE_TIPS[key]
  if (!i18nKey) return '-'
  let tip = i18n.t(i18nKey)
  if (!DEPRECATED_WORKFLOW_TYPES.includes(key) || typeof suspended !== 'boolean') {
    return tip
  }
  tip += i18n.t(suspended ? 'system.workflow_usage.suffix_deprecated' : 'system.workflow_usage.suffix_deprecated_enabled')
  return tip
}
